/* istanbul ignore file */
export { default } from './VehiclesDisplay';
